import { render } from "./Poetry.vue?vue&type=template&id=38e6bfa9"
import script from "./Poetry.vue?vue&type=script&lang=js"
export * from "./Poetry.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__